import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';
import { UNSUBSCRIBE_DO_UNSUBSCRIBE_QUERY_KEY, UNSUBSCRIBE_DO_UNSUBSCRIBE_URL } from '@modules/unsubscribe/constants';

export default function useUnsubscribeDoUnsubscribeMutation(): ReturnType<
  typeof useContextMutation<void, Error, string>
> {
  const { fetchGet } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    void,
    Error,
    string
  >({
    mutationKey: [UNSUBSCRIBE_DO_UNSUBSCRIBE_QUERY_KEY],
    mutationFn: (payload) => fetchGet(
      UNSUBSCRIBE_DO_UNSUBSCRIBE_URL,
      {
        urlParams: {
          token: payload,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [UNSUBSCRIBE_DO_UNSUBSCRIBE_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
